module.exports = __webpack_public_path__ + "img/8.f09ad321.jpg";